
const CollectionKeys = {
  THEMATIC_PACKAGES: 'thematicpackages',
  THEMATIC_PACKAGES_TRAITS: 'thematic-packages-traits',
  TRAITS: 'traits',
  ASSOCIATION_REPORTS: 'association-reports',
  ASSOCIATION_REPORT_VARIANTS: 'association-report-variants',
  VERSIONS: 'versions',
  SERIAL_NUMBER: 'serial-numbers',
  SIMULATIONS: 'simulations',
  DOCTORS: 'doctors',
  ADMIN_TOOL_USERS: 'admin-tool-users',
  REGISTRATION_KITS: 'registration-kits',
  REGISTRATION_KITS_FOR_REPORTS: 'registration-kits/new-find',
  QUESTIONNAIRES: 'questionnaires',
  CUSTOMER_QUESTIONNAIRE_ANSWERS: 'customer-questionnaire-answers',
  CONSENTS: 'consents',
  APPOINTMENTS: 'appointments',
  CUSTOMER_DOCTOR_KITS: 'customer-doctor-kits',
  LOCALES: 'locales',
  INVITATIONS: 'invitations',
  PROMO_CODES: 'promotion-codes',
  BUSINESSES: 'businesses',
  EMAIL_TEMPLATE_CATEGORIES: 'email-template-categories',
  LAB_FILES: 'runs',
  LAB_SAMPLES_SERIALS: '/registration-kits/labSampleSerials',
};

export default CollectionKeys;
